import React, { useState, useEffect } from 'react';
import './Members.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const Members = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const societyId = localStorage.getItem('societyId');
        
        if (!societyId) {
          setError('No organization selected');
          return;
        }

        const response = await fetch(
          `${API_URL}/api/v1/auth/orgs/members?access_token=${encodeURIComponent(token)}&org_id=${encodeURIComponent(societyId)}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch members');
        }

        const data = await response.json();
        if (data.status && data.Data) {
          setMembers(data.Data);
        }
      } catch (error) {
        console.error('Error fetching members:', error);
        setError('Failed to load members');
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  if (loading) {
    return <div className="members-loading">Loading members...</div>;
  }

  if (error) {
    return <div className="members-error">{error}</div>;
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="members-container">
      <h2>Organization Members</h2>
      <div className="members-list">
        {members.map((member) => (
          <div key={member.id} className="member-card">
            <div className="member-info">
              <h3>{`${member.firstName} ${member.lastName}`}</h3>
              <p className="member-email">{member.email}</p>
              <p className="member-since">Member since: {formatDate(member.createdDate)}</p>
              <p className="member-role">Role ID: {member.roleId}</p>
            </div>
          </div>
        ))}
      </div>
      {members.length === 0 && (
        <div className="no-members">No members found</div>
      )}
    </div>
  );
};

export default Members; 